module.exports = __webpack_public_path__ + "img/04.89a67fc0.png";